<template>
  <div class="page" v-if="pageType">
    <el-pagination
      background
      :page-size="pageSize"
      :layout="layout"
      :total="pageTotal"
      :current-page="currentPage"
      @current-change="pageChange"
      prev-text="上一页"
      next-text="下一页"
    ></el-pagination>
    <div class="page-contfirm">
      <el-button
          v-if="lan == 'ch'"
          :disabled="parseInt(pageTotal) < pageSize"
          class="tiaozhuan"
          @click="pageChange"
      >确定</el-button>
    </div>

  </div>
</template>
<script>
import Cookie from "../../../../common/cookie";
export default {
  props: {
    pageSize: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: "",
    },
    pageTotal: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    jumpColor:{
      type: String
    }
  },
  computed: {
    pageType() {
      // return this.pageTotal > this.pageSize
      return this.pageTotal > 0;
    },
  },
  data() {
    return {
      lan: Cookie.get("lang"),
      jumperColor:"",
      count:parseInt(this.pageTotal),
    };
  },
  watch:{
    pageTotal(){
      let me=this
      function setEn(){
        let elements=document.getElementsByClassName('el-pagination__jump')||[]
        for(let item of elements){
          item.style.color=me.jumperColor
          if (me.lan=='en') {
            if (elements.length!=0) {
              item.childNodes[0].data="Go to"
              item.childNodes[2].data="page"
            }else{
              setTimeout(setEn,100);
            }
          }
       }
    }
    setTimeout(setEn,100);
    }
  },
  mounted(){
    this.jumperColor=this.jumpColor
    let me=this
    function setEn(){
      let elements=document.getElementsByClassName('el-pagination__jump')||[]
      for(let item of elements){
        item.style.color=me.jumperColor
        if (me.lan=='en') {
          if (elements.length!=0) {
            item.childNodes[0].data="Go to"
            item.childNodes[2].data="page"
          }else{
            setTimeout(setEn,100);
          }
        }
      }
    }
    setTimeout(setEn,100);

  },
  created() {},
  methods: {
    pageChange(val) {
      this.$emit("pageChange", val);
    },
    handleSizeChange(val) {
        this.$emit("pageChange",  this.currentPage);
      // if (this.autoScroll) {
      //   scrollTo((this.forumTabsHeight || 0), 800)
      // }
    },
  },
};
</script>
<style>
.page .el-pagination {
  text-align: center;
  display: inline-block;
  /*flex:2;*/
  /*margin-top: 32px;*/
  /*margin-left: 20px;*/
}
.infoPub .page .el-pagination .btn-prev,
.infoPub .page .el-pagination .btn-next {
  width: 60px;
  height: 30px;
  background: #fff;
  margin: 0;
  margin-right: 20px;
  padding: 0;
  border: solid 1px #cccccc;
  border-radius: 4px;
  color: #333333;
  font-size: 12px !important;
}
.infoPub .page .el-pagination .el-pager li {
  width: 28px;
  height: 28px;
  line-height: 28px;
  color: #333333;
  background: #fff !important;
  font-size: 14px;
  margin: 0;
  margin-right: 20px;
  padding: 0;
  border-radius: 4px;
  font-weight: normal;
  border: solid 1px #cccccc;
}
.infoPub .page .el-pagination .el-pagination__jump {
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  color: #333333;
}
.infoPub .page .el-pagination .el-input__inner {
  width: 40px;
  height: 30px;
}
.infoPub .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #0071ff !important;
}
.tiaozhuan {
  display: inline-block;
  font-size: 13.5px;
  min-width: 50px;
  margin-left: 30px;
  /*margin-top: 2px;*/
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #FFFFFF !important;
  cursor: pointer;
  /* border: 1px solid #DCDFE6; */
  background: #0071ff !important;
  color: #fff;
  padding: 0 8px;
  border-radius: 5px;
  /*position: relative;*/
  /*left: 190px;*/
  /*top: -32px;*/
  /*float: right;*/
  /*flex: 3;*/
}
.page-contfirm {
  /*flex: 1;*/
  text-align: left;
  display: inline-block;
}

</style>
